var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGm = function SvgGm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0-48h640v480H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)",
    transform: "translate(0 48)",
    strokeWidth: "1pt"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0-128h640V85.33H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 85.333h640v35.556H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009",
    d: "M0 120.89h640v142.22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 263.11h640v35.556H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#090",
    d: "M0 298.67h640V512H0z"
  }))));
};
export default __webpack_public_path__ + "assets/5c1ff6b5e69b8f8e0f0f59684a7da2c4.svg";
export { SvgGm as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/gm.svg